import { ImagenSola as c } from "../EditPanel/ImagenSola";
import { conLanding } from "../Models/Landing";

export default class ImagenSola extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}